// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__17f1s","ranges":"BmiRanges_ranges__23q0d"};